import theme from '../../../lib/theme';
import { getBlockSpacing } from '../behaviour';
import { ContentLayoutBlockProps } from './ContentLayoutBlock';

const { layouts, scale, media, colors } = theme;

const flexGap = '1rem';

export default ({
  desktop_spacing,
  mobile_spacing,
  background_colour,
}: ContentLayoutBlockProps) => ({
  blockWrap: {
    backgroundColor: background_colour,
    padding: `${getBlockSpacing(mobile_spacing)} 0 ${getBlockSpacing(
      mobile_spacing
    )} 0`,

    [media.s.up]: {
      padding: `${getBlockSpacing(desktop_spacing)} 0 ${getBlockSpacing(
        desktop_spacing
      )} 0`,
    },
  },

  container: {},

  block_heading: {
    color: colors.black,
  },

  columnHeading: {
    fontSize: `${scale.s} !important`,
    color: colors.black,
  },

  columnContent: {
    fontSize: '1em !important',
    margin: '0',
  },

  mobileImage: {
    [media.m.up]: {
      display: 'none',
    },

    width: '100% !important',
    maxWidth: '100% !important',
    height: 'auto !important',
  },

  desktopImage: {
    [media.s.down]: {
      display: 'none',
    },
    width: '100% !important',
    maxWidth: '100% !important',
    height: 'auto !important',
  },
});
